import Button from "@components/Button";
import Modal, {
  ModalContent,
  ModalFooter,
  ModalHeader,
  ModalTitle,
} from "@components/Modal";

import styles from "./ConfirmModal.module.css";

interface ConfirmModalProps {
  onCancel: () => void;
  onConfirm: () => void;
  show: boolean;
  message: React.ReactNode;
  title: string;
  confirmText?: string;
  cancelText?: string;
}

const ConfirmModal: React.FC<ConfirmModalProps> = ({
  onCancel,
  onConfirm,
  show,
  message,
  title,
  confirmText = L.CONFIRM_ACTION,
  cancelText = L.CANCEL_ACTION,
}) => (
  <Modal show={show} onHide={onCancel}>
    <ModalHeader>
      <ModalTitle>{title}</ModalTitle>
    </ModalHeader>
    <ModalContent className={styles.content}>{message} </ModalContent>
    <ModalFooter>
      <Button variant="tertiary" onClick={onCancel}>
        {cancelText}
      </Button>

      <Button
        variant="primary"
        onClick={onConfirm}
        data-testid="modal-confirm-button"
      >
        {confirmText}
      </Button>
    </ModalFooter>
  </Modal>
);

export default ConfirmModal;
